import { apiClientSource } from "../common/axiosInstanceSource";
import { handleAxiosError } from "../common/handleAxiosError";
import { IDeleteAssignmentResponse } from "./types";

export const deleteAssignment = async (assignmentId: string): Promise<IDeleteAssignmentResponse> => {

  try {
    const response = await apiClientSource.delete(`/task-service/api/task-assignments/${assignmentId}`);
    return response.data;
  } catch (error) {
    handleAxiosError(error, "Error al eliminar la asignación");
    throw error;
  }
}